import { render, staticRenderFns } from "./ContestOfferCardHeader.vue?vue&type=template&id=3af4bde1&"
import script from "./ContestOfferCardHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContestOfferCardHeader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports